export default "__VITE_ASSET__VO7VIW4b__"